import React, { Component } from "react";

import { Image } from "react-konva";

class Drawing extends Component {
    state = {
        isDrawing: false,
        mode: "brush",
        brushSize: 0,
        currentBrushColor: "",
        brushColors: {
            default: "#df4b26",
            red: "##df4b26",
            blue: "#0074D9",
            yellow: "#FFDC00",
            black: "#111111",
            white: "#FFFFFF"
        }
    };

    componentDidMount() {
        const canvas = document.createElement("canvas");
        canvas.width = this.props.canvasWidth;
        canvas.height = this.props.canvasHeight;
        const context = canvas.getContext("2d");
        // console.log("[this.props.canvasHeight] " + this.props.canvasHeight + "[this.props.canvasWidth] " + this.props.canvasWidth)
        this.setState({ canvas, context, brushSize: this.props.brushSize, currentBrushColor: this.props.brushColor });
    }

    componentWillReceiveProps(props) {
        this.setState({ mode: props.mode, brushSize: props.brushSize, currentBrushColor: this.props.brushColor })
    }


    mouseDownHandler = () => {
        this.setState({ isDrawing: true });
        const stage = this.image.parent.parent;
        this.lastPointerPosition = stage.getPointerPosition();

    };

    mouseUpHandler = () => {
        this.setState({ isDrawing: false });

    };

    mouseLeaveHandler = () => {
        this.setState({ isDrawing: false });
    }

    mouseMoveHandler = () => {

        const { context, isDrawing, mode } = this.state;
        if (isDrawing) {
            // console.log("drawing");
            this.props.hasDrawnHandler(true)
            context.strokeStyle = this.state.currentBrushColor;
            context.lineJoin = "round";
            context.lineWidth = this.state.brushSize;

            if (mode === "brush") {
                context.globalCompositeOperation = "source-over";
            } else if (mode === "eraser") {
                context.globalCompositeOperation = "destination-out";
            }
            context.beginPath();

            var localPos = {
                x: this.lastPointerPosition.x - this.image.x(),
                y: this.lastPointerPosition.y - this.image.y()
            };
            // console.log("moveTo", localPos);
            context.moveTo(localPos.x, localPos.y);

            const stage = this.image.parent.parent;

            var pos = stage.getPointerPosition();
            localPos = {
                x: pos.x - this.image.x(),
                y: pos.y - this.image.y()
            };
            // console.log("lineTo", localPos);
            context.lineTo(localPos.x, localPos.y);
            context.closePath();
            context.stroke();
            this.lastPointerPosition = pos;
            this.image.getLayer().draw();
        }
    };

    render() {
        const { canvas } = this.state;
        // console.log("canvas", canvas);

        return (
            <Image
                image={canvas}
                ref={node => (this.image = node)}
                width={this.props.canvasWidth}
                height={this.props.canvasHeight}
                onMouseDown={this.mouseDownHandler}
                onMouseUp={this.mouseUpHandler}
                onMouseMove={this.mouseMoveHandler}
                onMouseLeave={this.mouseLeaveHandler}
                onTouchStart={this.mouseDownHandler}
                onTouchMove={this.mouseMoveHandler}
                onTouchEnd={this.mouseUpHandler}
            />
        );
    }
}

export default Drawing;